import { isNil } from 'lodash';
import { getObjectValue } from 'utilities';
import { CustomValidationsParams } from './createCustomValidations.types';
import { displayTotalComparisonWeightings, validateComparisonWeightingCells } from './utils';

const createCustomValidations = (params: CustomValidationsParams): void => {
  const {
    addFeedback,
    addFeedbackFromCell,
    cell,
    parsedColumns: parsedCells,
    removeFeedback,
    removeFeedbackFromCell,
  } = params;

  const { data } = getObjectValue(cell);
  const { capIqId, isWeighting = false } = getObjectValue(data);

  // Only run validation if this cell is a comparison weighting cell
  if (!isNil(capIqId) && isWeighting) {
    // Validate all comparison weighting cells and get the total
    const totalComparisonWeightings = validateComparisonWeightingCells({
      addFeedback,
      parsedCells,
      removeFeedback,
      removeFeedbackFromCell,
    });

    // If the total exists, show it on the weighted cell tooltip
    if (!isNil(totalComparisonWeightings)) {
      displayTotalComparisonWeightings({
        addFeedbackFromCell,
        parsedCells,
        totalComparisonWeightings,
      });
    }
  }
};

export default createCustomValidations;
